module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daylightsnow@2-8c771223476d80aac90562e25a5ade28.png";